import Vue from 'vue'
import Vuex from 'vuex'
// axios

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
	  // 语言
	  lang: localStorage.getItem('ilang') || 'zh_CN',
	  // Authorization
	  Authorization: localStorage.getItem('Authorization'),
	  // 登录后会员信息
	  member: JSON.parse(localStorage.getItem('member')),
	  admin: JSON.parse(localStorage.getItem('admin')) || {},
	  // 用户头像
	  avatar: require('@/assets/avatar.svg'), // 默认头像
	  // 上传统一 action
	  fileUpload: '',
	  //权限
	  permissions: JSON.parse(localStorage.getItem('permissions')||'[]'),
	  // 购物车数量
	  cartNum: 0,
	  // 未读消息数量
	  unread: 0,
  },
  getters: {
	 
  },
  mutations: {
	  // 更改 state
	  changeState(state, param) {
	      for (let i in param) {
	          state[i] = param[i]
	      };
		  
	  }
  },
  actions: {
  },
  modules: {
  }
})
